import styled from '@mui/material/styles/styled';

export const StyledOrderedList = styled('ol')({
  padding: 0,
  margin: 0,
});
